import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { IPrimaryKey } from "../../../../common/services/cqs/IPrimaryKey";

export abstract class KontraktBilagaCommandBase extends BasicCommand<KontraktBilagaCommandBase> {
    dokumentId: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "kontraktbilaga";

    get primaryKey(): IKontraktBilagaPrimaryKey {
        return {
            dokumentId: this.dokumentId
        };
    }
    constructor($type, commandType) {
        super($type, KontraktBilagaCommandBase.$groupKey, commandType);
    }
}

export interface IKontraktBilagaPrimaryKey extends IPrimaryKey<IKontraktBilagaPrimaryKey> {
    dokumentId: number;
}
